// extracted by mini-css-extract-plugin
export var reservationRecapContainer = "reservation-part-7-module--reservation-recap-container--65908";
export var reservationTitle = "reservation-part-7-module--reservation-title--2f176";